export const Url = {
	IMAGES: 'https://cdn.builder.io/api/v1/image/assets%',
	ICONS: 'https://img.icons8.com/?format=png&id=',
	/** Default source for icons (e.g. in list items, BragBar). Served from public/TotalInjuryHelp_logo.webp */
	DEFAULT_ICON: '/TotalInjuryHelp_logo.webp',
	/** Default placeholder for images (e.g. Hero, ContactUs, CopyAndImage). Served from public/80000VictimsHelped.webp */
	PLACEHOLDER_IMAGE: '/80000VictimsHelped.webp',
	HUBSPOT: 'https://js.hsforms.net/forms/v2.js',
} as const;
